import { pendingKeepsAppearanceClass } from '@/shared/components/Button';

/**
 * HeroUI's press scale is sized for a pill: on a wide row it pulls each edge in by ~8px, which
 * reads as the row collapsing. Full-width buttons get 0.985 in index.css; method rows aren't
 * always full-width buttons, so they carry it themselves.
 */
const rowPressClass =
  'active:[transform:scale(0.985)] data-[pressed=true]:[transform:scale(0.985)]';

/**
 * Grows to two lines instead of HeroUI's fixed height: connector names and translated labels
 * ("Continuer avec numéro de téléphone") outrun a 320px row, and two connectors differing only
 * at the end of the name would truncate to the same text.
 *
 * HeroUI's icon margin (`sm:my-1 -mx-0.5`) assumes a fixed height; here it grew a one-line row
 * to 46px and narrowed the icon gap next to the `<img>` logos, which get no margin.
 */
export const optionButtonClass = `${pendingKeepsAppearanceClass} h-auto min-h-11 py-2 whitespace-normal md:min-h-10 [&>svg]:m-0`;

/**
 * The label inside an option button; pairs with `optionButtonClass`. Start-aligned: a one-line
 * label shrinks to its text and is centred with the logo by the button anyway, while a wrapped
 * one fills the row and, centred, drifted away from the logo pinned at the start.
 */
export const optionLabelClass = 'min-w-0 text-start leading-5 text-pretty';

/** Shared HeroUI props for the sign-in option rows: social, SSO, passkey and phone. */
export const optionButtonProps = {
  variant: 'outline',
  size: 'lg',
  fullWidth: true,
} as const;

/** Two-line method rows (MFA factor, step-up method): icon, name + description, chevron. */
export const methodRowClass = `${pendingKeepsAppearanceClass} ${rowPressClass} group h-auto min-h-16 justify-start gap-3 rounded-[2.0625rem] p-3 text-start whitespace-normal`;
